import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import { mapGetters } from 'vuex'
import { filter } from "lodash";
export default {

    components: { 
        SettingsDropdown,
        LocDialog: () => import('./DialogBoxes/LocDialog.vue')
    },

    props: {
        details: {
            type: Object,
            default: () => {}
        },
        fetchLocations: {
            type: Function,
            default: () => {}
        },
    },

    data() {
        return{
            isAddLoc: false,
            searchValue: '',
            selectedSearchValue: '',
            isFetchingLocations: false,
            isEdit: false,
            searchLocations: [],
            isMove: false,
            
            locationList: [{
                name: 'Accura',
                country: 'Netherlands' 
            },{
                name: 'Amazon',
                country: 'USA'
            }],

            isFetchingPeople: false,
            columns: ['name', 'country', 'settings'],
            // selectedMenu: constants.PEOPLE_LIST.MEMBER,
            selectedMenu: '',
            tableSettings: {
                headings: {
                  name: 'Name',
                  country: 'Country',
                  settings: 'Settings',
                },
                pagination: { show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },

            settingOptions:[
                {command: 'EDIT_LOCATION', label: 'Edit'},
                {command: 'MOVE_LOCATION', label: 'Move'},
                {command: 'DELETE_LOCATION', label: 'Delete', isDelete: true}
            ],
            addressToBeEdited: {},
            clearLocFilter: false,
        }
    },

    computed: {
        ...mapGetters({
            locations: 'getLocations',
        }),
    },

    methods: {
        // handleFilters (item) {
        //     // to set the filters
        //     this.selectedSearchValue = item.data
        //     // to clear filters
        //     this.clearLocFilter = true
        //     this.searchValue = item.data
        //     this.changePage(1)
        // },

        // changeMenu (menu) {
        //     // to clear the skip, limit and order
        //     this.clearFields()
        //     // select menu
        //     this.selectedMenu = menu
        //     // to turn on fetching 
        //     this.isFetchingPeople = true
        //     // fetch people list based on menu
        //     this.fetchPeopleList()
        // },

        changeOrderName () {
            // change sort
            // this.order = this.order === 'desc' ? 'asc' : 'desc'
            // set skip to zero
            // this.skip = 0
            // fetch people list
            // this.fetchPeopleList()
        },

        changeOrderCountry () {

        },

        setTableFilters () {
            // this.selectedTableFilters = cloneDeep(filters)
            // this.$store.dispatch('setOganisationFilters', filters)
            // if (this.selectedSearchValue === '') this.changePage(1)
        },

        resetNameFilter () {
            // this.clearLocFilter = false
        },

        querySearch(search){
            const searchLocation = search ? filter(this.locations, (item) => {
                return item.locationtype.name_en_us.toLowerCase().includes(search.toLowerCase().trim()) || 
                item.locationtype.name_en_us.toLowerCase().includes(search.toLowerCase().trim())
            }) : this.locations
            this.searchLocations = [ ...searchLocation ];

        },

        handleFilters (item) {
            // to set the filters
            this.selectedSearchValue = item.data
            // to clear filters
            this.clearLocFilter = true
            this.searchValue = item.data
        },

        closeInviteDialog () {
            this.isAddLoc = false
            this.isEdit = false
            this.isMove = false
            this.addressToBeEdited = {}
        },

        handleCommand (option, data) {
            switch (option) {
                case 'MOVE_LOCATION':
                    this.isMove = true;
                    this.isAddLoc = true
                break
                case 'EDIT_LOCATION':
                    this.isEdit = true
                    this.addressToBeEdited = data
                    this.isAddLoc = true
                break
                case 'DELETE_LOCATION': 
                    this.$emit('removeLocation', data)
                break
                
            }
        },

        /**
         * 
         * @param {*} data 
         */
        editLocation (data) {
            this.addressToBeEdited = data
            this.isEdit = true
        }
    },
    watch: {
        locations(newLocations) {
            this.searchLocations = newLocations
        },
        searchValue(newSearchValue) {
            this.querySearch(newSearchValue)
        }
    },
}